var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $searchRendering = $('.search-rendering');

    if(!$searchRendering.length) {
        return;
    }

    var $filtersClearAllCTA = $searchRendering.find('.search-rendering__clear-filters');
    $filtersClearAllCTA.unbind('click');

    $searchRendering.on('click', '.search-rendering__clear-filters', function (e) {
        e.preventDefault();
        clearAll(e.target);
    });

    $('body').on('click', '.search-rendering__mobile-clear-button', function (e) {        
        e.preventDefault();
        $('.search-rendering__filter-checkbox').prop('checked', false);
        clearAll(e.target, false);
    });

    var clearAll = function (clearFiltersEl, shouldInsertResults) {
        shouldInsertResults = typeof shouldInsertResults !== 'undefined' ? shouldInsertResults : true;
        
        window.page = 1;        
        window.topics = [];
        window.types = [];
        window.typecategories = [];
        window.lastSearchRenderingFocusId = '';

        if (shouldInsertResults) {
            insertResults(apiEndpoint);
        }
    };
};